import { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { IconButton } from '../Button'
import { CloseIcon, Icon, SearchIcon } from '../Icons'
import { InputGroup } from '.'
import { Input, InputProps } from '@chakra-ui/react/input'

const SearchInput = (props: InputProps) => {
  const [search, setSearch] = useState<string>(`${props.value}` || '')
  const [searchValue] = useDebounce(search, 500)

  useEffect(() => {
    if (props.onChange) {
      const event = {
        target: {
          value: searchValue,
        },
      } as React.ChangeEvent<HTMLInputElement>

      props.onChange(event)
    }
  }, [searchValue])

  return (
    <InputGroup
      width="100%"
      endElementProps={{ paddingRight: '4px' }}
      endElement={
        <IconButton
          id="search-button"
          buttonAppearance="text"
          onClick={() => {
            if (search) {
              setSearch('')
            }
          }}
          size="xs"
        >
          <Icon boxSize="16px">{search ? <CloseIcon /> : <SearchIcon />}</Icon>
        </IconButton>
      }
    >
      <Input
        {...props}
        bgColor="ge.white"
        color="ge.text.primary"
        borderColor="ge.input.outline"
        borderRadius="6px"
        onChange={(e) => {
          setSearch(e.target.value)
        }}
        width="100%"
        value={search}
      />
    </InputGroup>
  )
}

export default SearchInput
